import "./ChatScreen.scss"
import * as chatComponents from "../chat-components"
import { useEffect, useState } from "react"
import { ChatTypeEnum, IChatResponse, IMessage } from "../../../shared/models/chat_models"
import { postChatAPI } from "../../../shared/api/chat_api"
import { AppDispatch, RootState } from "../../../shared/store"
import { useSelector, useDispatch } from "react-redux"
import { fetchAllowedChatDatasets, fetchAllowedChatTypes, setSelectedChatType } from "../chat-slice"


export const ChatScreen = () => {

        const chatSlice = useSelector((state: RootState) => state.chat)
        const dispatch: AppDispatch = useDispatch();
        const [loading, setLoading] = useState(false)   
        const [messages, setMessages] = useState<Array<IMessage>>([])

        useEffect(() => {
            if(!chatSlice.allowedChatTypes)
                dispatch(fetchAllowedChatTypes())

            if(!chatSlice.allowedDatasets)
                dispatch(fetchAllowedChatDatasets())
        }, [])

    
        const handleQuerySent = (query: string) => {
            setLoading(true)
            let newMessages = [...messages]
            newMessages.push({role: 'user', content: query})
            setMessages(newMessages)
            
            if(!chatSlice.selectedDataset || !chatSlice.selectedChatType)
                return
            
            if (chatSlice.selectedChatType === ChatTypeEnum.QNA){
                postChatAPI<string>(newMessages, chatSlice.selectedDataset, chatSlice.selectedChatType)
            } else if (chatSlice.selectedChatType === ChatTypeEnum.QUERY){
                postChatAPI<IChatResponse>(newMessages, chatSlice.selectedDataset, chatSlice.selectedChatType).then((res) => {
                    newMessages.push({role: 'assistant', content: res.data})
                    setMessages(newMessages)
                }).catch((e) => {
                    console.error("Error in postChatAPI")
                }).finally(() => {
                    setLoading(false)
                })
            }
        }
    

    return (
        <div className='chat-page'>
            <div className='title'>
                <h2 className='header'>Search</h2>
                <h5 className='subheader'>powered by Spacecow LLC</h5>
            </div>
            <div>
                <chatComponents.Chat 
                    sendQuery={handleQuerySent}
                    messages={messages}
                    loading={loading}
                    chatOptions={chatSlice.chatOptions || []}
                    selectedChatType={chatSlice.selectedChatType || ""}
                    setSelectedChatType={(chatType) => dispatch(setSelectedChatType(chatType))}
                />
            </div>
        </div>
    )
}